module.exports = __webpack_public_path__ + "img/sureImg.431306d3.svg";